var _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutodocAppIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5627_926)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_5627_926)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3479 42.857C27.218 42.8572 28.0525 43.203 28.6677 43.8183C29.2829 44.4337 29.6286 45.2683 29.6286 46.1384V55.9998H41.1386V34.382C41.1387 33.951 41.054 33.5242 40.8892 33.1259C40.7243 32.7277 40.4826 32.3658 40.1779 32.061C39.8732 31.7562 39.5114 31.5144 39.1132 31.3495C38.7149 31.1846 38.2881 31.0998 37.8571 31.0999H16V42.857H26.3479Z",
    fill: "#F85A00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.6522 29.1428C44.782 29.1427 43.9475 28.7969 43.3323 28.1815C42.7171 27.5661 42.3714 26.7316 42.3714 25.8614V16H30.8615V37.6178C30.8614 38.0488 30.9462 38.4756 31.111 38.8738C31.2759 39.272 31.5176 39.6338 31.8223 39.9386C32.127 40.2434 32.4888 40.4852 32.887 40.6501C33.2851 40.8151 33.7119 40.9 34.1429 40.9H56V29.1428H45.6522Z",
    fill: "#132530"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3479 42.857C27.218 42.8572 28.0525 43.203 28.6677 43.8183C29.2829 44.4337 29.6286 45.2683 29.6286 46.1384V55.9998H41.1386V34.382C41.1387 33.951 41.054 33.5242 40.8892 33.1259C40.7243 32.7277 40.4826 32.3658 40.1779 32.061C39.8732 31.7562 39.5114 31.5144 39.1132 31.3495C38.7149 31.1846 38.2881 31.0998 37.8571 31.0999H16V42.857H26.3479Z",
    fill: "#F85A00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.6522 29.1428C44.782 29.1427 43.9475 28.7969 43.3323 28.1815C42.7171 27.5661 42.3714 26.7316 42.3714 25.8614V16H30.8615V37.6178C30.8614 38.0488 30.9462 38.4756 31.111 38.8738C31.2759 39.272 31.5176 39.6338 31.8223 39.9386C32.127 40.2434 32.4888 40.4852 32.887 40.6501C33.2851 40.8151 33.7119 40.9 34.1429 40.9H56V29.1428H45.6522Z",
    fill: "#132530"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5627_926",
    x: -24,
    y: -24,
    width: 120,
    height: 120,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect1_foregroundBlur_5627_926"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5627_926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutodocAppIcon);
export default __webpack_public_path__ + "static/media/autodoc-app-icon.7ff39c895b08886ac7c789e21b77f193.svg";
export { ForwardRef as ReactComponent };